import { render, staticRenderFns } from "./EtapaRFID.vue?vue&type=template&id=00646924"
import script from "./EtapaRFID.vue?vue&type=script&lang=js"
export * from "./EtapaRFID.vue?vue&type=script&lang=js"
import style0 from "./EtapaRFID.vue?vue&type=style&index=0&id=00646924&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports